module.exports = __webpack_public_path__ + "static/img/home_tzjsmfw_swkc.7caea66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_tzjsmfw_swkc.png
// module id = 0BIC
// module chunks = 21